import httpService from "../../Service/httpService";

const controller = "NotaMedica";


export const getPacientesSesion = async (id, idEnf, fecha, hora) => {
	const res = await httpService.get(`/${controller}/getPacientesSesion/${id}/${idEnf}/${fecha}/${hora}`);
	return res.data;
};

export const getDataFromHE = async (id, idSesion) => {
	const res = await httpService.get(`/${controller}/getDataFromHE/${id}/${idSesion}`);
	return res.data;
};

export const getDatosNotaMedica = async (id, idNota) => {
	const res = await httpService.get(`/${controller}/getDatosNotaMedica/${id}/${idNota}`);
	return res.data;
};

export const getDatosNotaMedicaView = async (id, idSesion) => {
	const res = await httpService.get(`/${controller}/getDatosNotaMedicaView/${id}/${idSesion}`);
	return res.data;
};


export const inicioNotaMedica = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/inicioNotaMedica`, {
	...data,
	});
	return res;
};

export const saveCampo = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveCampo`, {
	...data,
	});
	return res;
};

export const saveFirmaNota = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveFirmaNota`, {
	...data,
	});
	return res;
};

